<section class="crm-signin">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <p class="brand crm-brand">
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path d="M21.6 7.4a10 10 0 1 0 .15 17.2" />
        <path d="M15.2 19.4 20.4 13.2 22.8 15.4 27.4 9" />
      </svg>
      <span class="brand-name">Capi<em>Trade</em></span>
    </p>
    <h1>CRM</h1>
    <p>Sign in with your admin or agent email.</p>
    @if (serverError(); as message) {
      <p class="banner" role="alert">{{ message }}</p>
    }
    <label>
      Email
      <input type="email" formControlName="email" autocomplete="username" />
    </label>
    <label>
      Password
      <input type="password" formControlName="password" autocomplete="current-password" />
    </label>
    <button class="btn light" type="submit" [disabled]="submitting()">
      {{ submitting() ? 'Signing in…' : 'Sign in' }}
    </button>
  </form>
</section>
